import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  SubscribePayload,
  SubscribeResponse,
  RequestResponse,
} from '@/types';

export const subscribe = async (payload: SubscribePayload) => {
  const response = await axiosInstance.post<RequestResponse<SubscribeResponse>>(
    endpoints.subscribe,
    payload
  );
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await axiosInstance.post<RequestResponse<null>>(
    endpoints.cancelSubscription
  );
  return response.data;
};
